<template>
  <div class="home-container ">
    <div class="modal">
      <!--加载中-->
      <div class="top-user-info flex-column-center" v-if="isLogin && authLoading">
        <van-loading type="spinner" color="#1989fa" size="36px" />
      </div>
      <!--未登录-->
      <div class="top-user-info flex-column-center" v-else-if="!isLogin">
        <img :src="bannerUrl1" alt="">
        <div class="desc">{{$t('index.label1')}}</div>
        <Button class="btn" @click="toPath('login')">{{$t('index.label2')}}</Button>
      </div>
      <!--已登录未认证-->
      <div class="top-user-info flex-column-center" v-else-if="authStatus != 2">
        <img :src="bannerUrl2" alt="">
        <div class="desc" v-if="authStatus == 1">{{$t('index.label3')}}</div>
        <div class="desc" v-else>{{$t('index.label4')}}</div>
        <Button class="btn" :disabled="authStatus == 1" @click="toPath('userAuth')">{{$t('index.label5')}}</Button>
      </div>
      <!--已认证-->
      <div class="top-user-info flex-column-center" v-else>
        <img :src="bannerUrl3" alt="">
        <div class="desc">{{$t('index.label6')}}</div>
        <div class="flex-center">
          <Button class="btn gray small" @click="toPath('withdraw')">{{$t('index.label7')}}</Button>
          <Button class="btn small" @click="toPath('recharge')">{{$t('index.label8')}}</Button>
        </div>
      </div>

      <!--菜单-->
      <div class="menu-list flex-center">
        <div class="menu flex-column-center" v-for="(item, i) in menuList" :key="i" @click="toPath(item.path)">
          <img :src="item.url" alt="">
          <div>{{item.name}}</div>
        </div>
      </div>

      <div class="recommend-list flex-center-between">
        <div class="recommend flex-column-center" v-for="(item, i) in recommendList" :key="i">
          <div class="flex">
            <div class="name">
              <span class="white">{{item.ShortName}}</span>/ USDT
            </div>

          </div>
          <div class="count" >{{item.count || 0}}</div>
          <div class="percent" :class="item.percent >= 0 ? 'green' : 'red'">
            {{item.percent >= 0 ? '+' : ''}}{{item.percent}}%
          </div>
        </div>
      </div>

      <div class="notice-bar flex">
        <NoticeBar
          :left-icon="noticeUrl"
          :text="noticeMsg"
          color="#50535C"
          background="none"
        >
        </NoticeBar>
        <!-- <div class="flex-1 flex-center">
          <img :src="noticeUrl" alt="">
          <div class="msg-box">
            <div class="msg-inner">
              <div class="msg left1" id="msg1" :style="msgStyle1">{{noticeMsg}}</div>
              <div class="msg left2" id="msg2" :style="msgStyle2">{{noticeMsg}}</div>
            </div>
          </div>
        </div> -->

        <div class="more-btn flex-center" @click="toPath('notice')">
          <img :src="moreUrl" alt="">
        </div>
      </div>

      <div class="rank-title flex">
        <div class="title" v-for="(item, i) in rankType" :key="i" :class="rankIndex == i ? 'active' : ''" @click="changeRank(i)">{{item}}</div>
      </div>

      <div class="rankList">
        <div class="table-th flex-center">
          <div class="th flex-3">{{$t('index.label9')}}</div>
          <div class="th flex-2 text-right">{{$t('index.label10')}}(USDT)</div>
          <div class="th flex-2 text-right">{{$t('index.label11')}}</div>
        </div>
        <bit-page :dataList="rankList" @detail="toDetail"></bit-page>
      </div>
    </div>
  </div>
</template>

<script>
import { getCoinList, quoteList, getNoticeList } from '@/api/index'
import { checkAuth } from '@/api/setting'
import { userInfo } from '@/api/user'
import { Button, Swipe, SwipeItem, Popup, NoticeBar, Loading as VanLoading } from 'vant'
import moment from 'moment'
import bitPage from '@/components/bit'
import {initWebSocket, sortByField} from '@/utils/common'
import {setUser, setUserAvatar, setUserEmail, setUserId, getUserAvatar, getToken, setRemark} from '@/utils/auth'
import { customerList } from '@/api/setting'
import { isQiabotNewType, openQiabotWidget, QIABOT_NEW_TYPE } from '@/utils/qiabot'
import "@/utils/sdk.js"
export default {
  name: 'about',
  components: {
    Button,
    Swipe,
    SwipeItem,
    Popup,
    bitPage,
    NoticeBar,
    VanLoading
  },
  data() {
    return {
      authStatus: null,
      authLoading: false,
      authLoading: false,
      reconnectTimer: null,
      stompClient: null,
      isComponentDestroyed: false,
      webSocket: '',
      avatar: '',
      noticeMsg: '',
      bannerUrl1: require('../../assets/imgs/banner1.png'),
      bannerUrl2: require('../../assets/imgs/banner1.png'),
      bannerUrl3: require('../../assets/imgs/banner1.png'),
      userUrl: require('../../assets/imgs/icon-user.png'),
      closeUrl: require('../../assets/imgs/icon-close.png'),
      noticeUrl: require('../../assets/imgs/icon-notice.png'),
      moreUrl: require('../../assets/imgs/icon-more.png'),
      usdtUrl: require('../../assets/imgs/icon-usdt.png'),
      logoUrl: require('../../assets/imgs/logo.png'),
      rightUrl: require('../../assets/imgs/icon-arrow-right.png'),
      showRecharge: false,
      isInitQuote: false,
      rechargeIndex: -1,
      rechargeName: '',
      recommendList: [],
      menuList: [
        {
          url: require('../../assets/imgs/icon-finaice.png'),
          name: this.$t('index.menu1'),
          path: 'finance'
        },
        {
          url: require('../../assets/imgs/icon-gift.png'),
          name: this.$t('index.menu2'),
          path: 'rewardDetail'
        },
        // {
        //   url: require('../../assets/imgs/icon-share.png'),
        //   name: this.$t('index.menu3'),
        //   path: 'share'
        // },
        // {
        //   url: require('../../assets/imgs/icon-follow.png'),
        //   name: this.$t('index.menu4'),
        //   path: 'follow'
        // },
      ],
      rankType: [
        this.$t('index.rank1'),
        this.$t('index.rank2'),
        this.$t('index.rank3'),
      ],
      rankIndex: 1,
      rankListBak: [],
      rankList: [  ],
      bitListBak: [],
      quoteListBak: [],
      headerObj:{
        'header-1':  require('../../assets/imgs/header/header-1.png'),
        'header-2':  require('../../assets/imgs/header/header-2.png'),
        'header-3':  require('../../assets/imgs/header/header-3.png'),
        'header-4':  require('../../assets/imgs/header/header-4.png'),
        'header-5':  require('../../assets/imgs/header/header-5.png'),
        'header-6':  require('../../assets/imgs/header/header-6.png'),
        'header-7':  require('../../assets/imgs/header/header-7.png'),
        'header-8':  require('../../assets/imgs/header/header-8.png'),
        'header-9':  require('../../assets/imgs/header/header-9.png'),
        'header-10':  require('../../assets/imgs/header/header-10.png'),
        'header-11':  require('../../assets/imgs/header/header-11.png'),
        'header-12':  require('../../assets/imgs/header/header-12.png'),
        'header-13':  require('../../assets/imgs/header/header-13.png'),
        'header-14':  require('../../assets/imgs/header/header-14.png'),
      },
      showKefu: false,
      kefuList: [],
      isLogin: false,
      userAuth: false,
      tabBitList1: [], // 主流币
      tabBitList3: [], // 热门币
      msgWidth: '',
      time1: '',
      time2: '',
      msgLeft1: 290,
      msgLeft2: 290,
      moveIndex: 2,
      timer: ''
    }
  },
  computed: {
    msgStyle1() {
      return {
        // width: `${this.msgWidth}px`,
        transition: this.time1 ? `all ${this.time1}s linear` : '',
        left: `${this.msgLeft1 * this.screenScale}px`
      }
    },
    msgStyle2() {
      return {
        // width: `${this.msgWidth}px`,
        transition: this.time2 ? `all ${this.time2}s linear` : '',
        left: `${this.msgLeft2 * this.screenScale}px`
      }
    },
    appName() {
      return this.$store.state.appName
    },
    isSend() {
      return this.$store.state.isSend
    },
    bitList() {
      return this.$store.state.bitList
    },
    showWelcome() {
      return this.$store.state.showWelcome
    },
    screenScale() {
      return this.$store.state.screenScale
    },
  },
  mounted() {
    if (getToken()) {
      this.isLogin = true
      this.authLoading = true
      this.initStatus()
    }
    this.init()
    this.initSocket()
    this.initQuote()
    document.addEventListener('visibilitychange', this.handleVisibilityChange)

  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    clearInterval(this.timer)
    clearTimeout(this.reconnectTimer)
    this.$store.state.isSend = false
    this.isComponentDestroyed = true
    if (this.stompClient && this.stompClient.connected) {
      this.$store.state.isClose = true
      this.stompClient.disconnect()
    } else if (this.webSocket && this.webSocket.close) {
      this.$store.state.isClose = true
      this.webSocket.close()
    }
  },
  methods: {
    getUserAvatar,
    toPath(path) {
      if (path == 'share' && !this.isLogin) {
        this.$router.push({
          name: 'login'
        })
      } else {
        if (path) {
          this.$router.push({
            name: path
          })
        }
      }
    },
    initMsg() {
      let space = this.getWidth()
      let lineWidth = 290
      let time3 = space / 100 + lineWidth / 100
      this.msgWidth = space * this.screenScale
      this.time1 = time3
      this.time2 = time3


      setTimeout(() => {
        this.msgLeft1 = -space
      }, 300)
      this.timer = setInterval(() => {
        if (this.moveIndex == 1) {
          this.msgLeft1 = 290
          this.time1 = ''
          setTimeout(() => {
            this.time1 = time3
            this.msgLeft1 = -space
          }, 300);
        } else {
          this.msgLeft2 = 290
          this.time2 = ''
          setTimeout(() => {
            this.time2 = time3
            this.msgLeft2 = -space
          }, 300);
        }
        this.moveIndex = this.moveIndex == 2 ? 1 : 2
      }, (this.time1 - 2) * 1000);
    },
    getWidth() {
      let total = 0;
      let str = this.noticeMsg.replace(/(\n)/g, ' ')
      for (let i = 0; i < str.length; i++) {
        if (/[\u4e00-\u9fa5]/.test(str[i])) { // 判断是否为中文字符
          total += 14
        } else if (str[i] == ' ') {
          total += 5
        } else {
          total += 10
        }
      }
      return total;
    },
    initQuote() {
      //最新行情
      quoteList().then(res => {
        this.quoteListBak = res.data
        this.mergeQuotes()
      })
    },
    mergeQuotes() {
      if (!this.quoteListBak || !this.quoteListBak.length) {
        return
      }
      
      const updateItem = (v) => {
        let val = this.quoteListBak.find(item => {
          return item.CurrencyId == v.ID
        })
        if (val) {
          let close = parseFloat(val.Close)
          let open = parseFloat(val.Open)
          let percent = 0
          if (open > 0) {
            percent = parseFloat(((close - open) / open * 100).toFixed(2))
          }

          // Use cached percent if API returns 0 change (Open == Close) but we have history
          if (percent === 0 && v.percent !== 0 && v.percent !== undefined) {
             percent = v.percent
             // Also keep Yesterday if it seems more valid for this percent
             if (v.Yesterday > 0) {
               open = v.Yesterday
             }
          }

          v.Close = close
          v.Yesterday = open
          v.percent = percent
          v.count = close
        }
      }

      this.rankListBak.forEach(updateItem)
      this.bitListBak.forEach(updateItem)

      this.changeRank(this.rankIndex)
      
      this.recommendList = this.rankListBak.filter(v => {
          return v.IsRecommend == 1 && v.HomeShow == 1
        }).sort((a, b) => {
          return a.Order - b.Order
        }).slice(0, 3)
      this.recommendList = sortByField(this.recommendList, 'Order',"asc")
      
      if (this.bitListBak.length > 0) {
        this.$store.state.bitList = [].concat(this.bitListBak)
        localStorage.setItem('bitList', JSON.stringify(this.bitListBak))
      }
    },
    init() {
      //币种列表
      let list = localStorage.getItem('bitList')
      if (list && list != 'undefined' && this.bitList.length == 0) {
        this.$store.state.bitList = JSON.parse(list)
      }
      if (this.bitList.length > 0) {
        this.rankListBak = [].concat(this.bitList)
        // 涨幅榜按涨幅排序，其他按order等字段排序
        this.rankList = this.rankListBak.filter(v => {
          return v.HomeShow == 1
        }).sort((a, b) => {
          return Math.abs(b.percent) - Math.abs(a.percent)
        }).slice(0, 8)
        // this.initQuote()
        this.recommendList = this.rankList.filter(v => {
          return v.IsRecommend == 1 && v.HomeShow == 1
        }).sort((a, b) => {
          return a.Order - b.Order
        }).slice(0, 3)

        this.recommendList = sortByField(this.recommendList, 'Order',"asc")
        this.mergeQuotes()
      }

      getCoinList().then(res => {
        // Cache lookup
        const cachedMap = new Map();
        try {
          const localCache = localStorage.getItem('bitList');
          if (localCache) {
            const parsedCache = JSON.parse(localCache);
            if (Array.isArray(parsedCache)) {
              parsedCache.forEach(item => {
                cachedMap.set(String(item.ID), item);
              });
            }
          }
        } catch (e) {
          console.error("Cache parse error", e);
        }

        const processItem = (v) => {
          const cached = cachedMap.get(String(v.ID));
          if (cached) {
            v.percent = cached.percent || 0;
            v.Close = cached.Close || 0;
            v.Yesterday = cached.Yesterday || 0;
            v.count = cached.count || 0;
            v.Open = cached.Open || 0;
          } else {
            v.percent = 0;
          }
          return v;
        }

        this.bitListBak = res.data.Items.map(v => processItem({...v}))
        this.rankListBak = res.data.Items.map(v => processItem({...v}))

        this.changeRank(this.rankIndex)
        // this.rankList = this.rankListBak.filter(v => {
        //   return v.HomeShow == 1
        // }).sort((a, b) => {
        //   return a.HomeOrder - b.HomeOrder
        // }).slice(0, 8)

        this.recommendList = this.rankListBak.filter(v => {
          return v.IsRecommend == 1 && v.HomeShow == 1
        }).sort((a, b) => {
          return a.Order - b.Order
        }).slice(0, 3)
        this.recommendList = sortByField(this.recommendList, 'Order',"asc")
        this.recommendList = sortByField(this.recommendList, 'Order',"asc")
        this.$store.state.bitList = [].concat(this.bitListBak)
        if (this.bitListBak.length > 0) {
          localStorage.setItem('bitList', JSON.stringify(this.bitListBak))
        }
        this.mergeQuotes()
      })


      //客服
      customerList().then(res => {
        this.kefuList = res.data.Items
      })

      //用户信息
      if (getToken()) {
        userInfo().then(res => {
          let data = res.data
          setUser(data.Email || data.Phone || '')
          setUserEmail(data.Email)
          setUserId(data.ID)
          setRemark(data.Remark)
          this.$store.state.shareCode = data.InviteCode
        })
      } else {
        this.avatar = ''
      }

      // 公告
      getNoticeList().then(res => {
        let list = res.data.Items
        if (list.length > 0) {
          this.noticeMsg = list[0].Content
          // this.initMsg()
        }
      })


    },
    initStatus() {
       // 用户认证状态
      checkAuth().then(res => {
        this.authStatus = res.data.status
      }).finally(() => {
        this.authLoading = false
      })
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        if (!this.stompClient || !this.stompClient.connected) {
          this.initSocket()
        }
      }
    },
    async initSocket(){ //初始化weosocket
      if (this.stompClient && this.stompClient.connected) {
        this.stompClient.disconnect()
      }
      try {
        let client = await initWebSocket('all', this.websocketonmessage, this.websocketonerror)
        if (this.isComponentDestroyed) {
          client.disconnect()
          return
        }
        this.stompClient = client
        this.webSocket = client.ws
      } catch (e) {
        // Handled by websocketonerror normally, but catch here for initial await failure
        console.error(e)
      }
    },
    websocketonerror(e) {
      if (this.isComponentDestroyed) return
      console.log('socket error', e)
      clearTimeout(this.reconnectTimer)
      this.reconnectTimer = setTimeout(() => {
        this.initSocket()
      }, 3000)
    },
    websocketonmessage(e){ //数据接收
      let data = e.data
      let redata = {}
      try {
        redata = JSON.parse(e.data)
        // console.log('[Debug] WS message', redata.tags?.InstId);
        this.setListData(redata)
      }
      catch(e) {
      }
    },
    setListData(data) {
      let index = this.rankListBak.findIndex(v => {
        return v.ShortName + '-USDT' == data.tags.InstId
      })
      let recommendIndex = this.recommendList.findIndex(v => {
        return v.ShortName + '-USDT' == data.tags.InstId
      })
      let bitIndex = this.bitListBak.findIndex(v => {
        return v.ShortName + '-USDT' == data.tags.InstId
      })
      let valObj = data.fields
      
      // Safety check for calculation
      let yesterday = valObj.Yesterday || valObj.Open || 0
      let percent = 0
      if (yesterday > 0) {
        percent = parseFloat(((valObj.Close - yesterday) / yesterday * 100).toFixed(2))
      }

      const updateData = (targetList, index) => {
        targetList[index] = {
          ...targetList[index],
          ...valObj,
          percent,
          count: valObj.Close,
        }
      }

      if (index > -1) {
        updateData(this.rankListBak, index)
        updateData(this.bitListBak, bitIndex)
        if (this.bitListBak.length > 0) {
          this.$store.state.bitList = [].concat(this.bitListBak)
          localStorage.setItem('bitList', JSON.stringify(this.bitListBak))
        }
      }

      if (recommendIndex > -1) {
        updateData(this.recommendList, recommendIndex)
      }

      // this.rankListBak.sort((a, b) => {
      //   return Math.abs(b.percent) - Math.abs(a.percent)
      // })


      if (this.rankIndex == 0) {
        this.rankList = this.rankListBak.filter(v => {
          return v.IsMain == 1 && v.HomeShow == 1
        }).sort((a, b) => {
          return a.MainOrder - b.MainOrder
        })
      } else if (this.rankIndex == 1) {
        this.rankList = this.rankListBak.filter(v => {
          return v.HomeShow == 1
        }).sort((a, b) => {
          return Math.abs(b.percent) - Math.abs(a.percent)
        }).slice(0, 8)
      } else if (this.rankIndex == 2) {
         this.rankList = this.rankListBak.filter(v => {
          return v.IsHot == 1 && v.HomeShow == 1
        }).sort((a, b) => {
          return a.HotOrder - b.HotOrder
        })
      }


      this.recommendList = this.rankListBak.filter(v => {
        return v.IsRecommend == 1 && v.HomeShow == 1
      }).sort((a, b) => {
        return a.Order - b.Order
      }).slice(0, 3)
    },
    toDetail(data) {
      this.$router.push({
        name: 'trade',
        query: {
          name: data.ShortName,
          id: data.ID,
          type: 2
        }
      })
    },
    toRecharge() {
      this.showRecharge = true
    },
    changeRecharge(data, i) {
      this.rechargeIndex = i
      this.rechargeName = data.name
    },
    toRechargePage() {
      if (this.rechargeName == 'Bank') {
        this.$router.push({
          name: 'kefu'
        })
      } else {
        this.$router.push({
          path: '/recharge?type=' + this.rechargeName
        })
      }
    },
    cancel() {
      this.showRecharge = false
      this.showKefu = false
    },
    toKefu() {
      this.showKefu = true
    },
    chooseKefu(data) {
      this.showKefu = false
      this.to(data.Type, data.Link)
    },
    to(Type, Link) {
      let tmp = undefined
      let that = this
      if(isQiabotNewType(Type)) {
        window.localStorage.setItem('kefuType', QIABOT_NEW_TYPE)
        openQiabotWidget(Link).catch(error => {
          console.error('qiabot新版打开失败:', error)
        })
      } else if(Type == "chatwoot") {
        if(window.$chatwoot === undefined) {
          tmp = setInterval(function (){
            // that.chatwoot()
            if (window.$chatwoot !== undefined) {
              clearInterval(tmp)
              window.$chatwoot.toggle('open');
            }
          },50)
        } else {
          window.$chatwoot.toggle('open');
        }
      } else if (Type == 'meiqia') {
        this.$router.push({
          name: 'kefu'
        })
      } else {
        switch (Type) {
          case "wechat":
            Link = "weixin://" + Link
            break;
          case "qq":
            Link = "mqq://"+ Link
            break;
          case "whatsapp":
            Link = "whatsapp://send?phone="+ Link
            break;
          case "telegram":
            Link = "tg://resolve?domain="+ Link
            break;
          case "facebook":
            Link = "fb://"+ Link
            break;
          case "twitter":
            Link = "twitter://"+ Link
            break;
          case "instagram":
            Link = "instagram://"+ Link
            break;
            case "line":
            Link = "https://line.me/R/"+ Link
            break;
        }
        this.toKefuPath(Link)
      }
    },
    toKefuPath(path) {
      let a = document.createElement('a')
      a.href = path
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    changeRank(i) {
      this.rankIndex = i
      if (i == 0) {
        this.rankList = this.rankListBak.filter(v => {
          return v.IsMain == 1 && v.HomeShow == 1
        }).sort((a, b) => {
          return a.MainOrder - b.MainOrder
        })
      } else if (i == 1) {
        this.rankList = this.rankListBak.filter(v => {
          return v.HomeShow == 1
        }).sort((a, b) => {
          return Math.abs(b.percent) - Math.abs(a.percent)
        }).slice(0, 8)
      } else if (i == 2) {
         this.rankList = this.rankListBak.filter(v => {
          return v.IsHot == 1 && v.HomeShow == 1
        }).sort((a, b) => {
          return a.HotOrder - b.HotOrder
        })
      }
    }
  },
}
</script>
<style lang="less">

</style>
